import React from "react";
import {useNavigate} from "react-router-dom";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useEffect} from "react";
import {useState} from "react";
import {useLocation, matchPath} from "react-router-dom";
import {
    useAppKit,
    useAppKitAccount,
    useAppKitNetwork,
    useAppKitNetworkCore,
    useAppKitProvider,
} from "@reown/appkit/react";
import {ethers, JsonRpcSigner} from "ethers";
import {saveCryptoPresalePayment} from "../../presale/presale_form/api";
import {ethRecipientAddress, recipientAddress} from "../../../common/constant/api_key";
import {SystemProgram, PublicKey, Transaction, LAMPORTS_PER_SOL, Connection} from "@solana/web3.js";
import {solappKit} from "../../../common/appkitConfig.tsx";
import {updateUserSubscriptionWithWllet} from "../../../apihelper/profile.js";
import {CircularProgress} from "@mui/material";
import SuccessPaymentAlert from "../../../common/alert/SuccessPaymentAlert.jsx";
import ProcessingAlert from "../../../common/alert/ProcessingAlert.jsx";

const WalletPayment = ({onClose, open}) => {
    const [isReferrer, setIsReferrer] = useState(false);
    const location = useLocation();
    const [processingError, setProcessingError] = useState(false);
    const {address, isConnected, blockchain} = useAppKitAccount();
    // const [walletProvider, setWalletProvider] = useState(null);
    // const {walletProvider} = useAppKitProvider(solappKit);
    const {walletProvider} = useAppKitProvider("eip155", {
        autoSwitchNetwork: false,
    });
    const [walletAddress, setWalletAddress] = useState("");
    const [provider, setProvider] = useState();
    const {switchNetwork, chainId} = useAppKitNetwork();
    const select_price = 12;
    const [isSuccess, setIsSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [alertMessage, setAlertMessage] = useState("");
    const [snackbaropen, setSnackbarOpen] = useState(false);
    const [severity, setSeverity] = useState(false);
    const navigate = useNavigate()

    console.log("Block chain", blockchain);

    console.log("Wallet Provider:", address, isConnected, useAppKitProvider());
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    useEffect(() => {
        console.log("Test Wallet Provider:", walletProvider);
    }, [walletProvider]);
    const {wallet} = useAppKit();
    const [network, setNetwork] = useState(null);
    useEffect(() => {
        async function fetchNetwork() {
            // For Ethereum-based wallets
            console.log("wallet.ethereumProvider", wallet);
            if (wallet.ethereumProvider) {
                const chainId = await wallet.ethereumProvider.request({method: "eth_chainId"});
                setNetwork(chainId);
            } else if (wallet.connection) {
                // For Solana wallets, you might keep track of your connection URL/network manually
                setNetwork(wallet.connection.rpcEndpoint || "Unknown network");
            } else {
                setNetwork("Unknown network");
            }
        }

        if (wallet?.connected) {
            fetchNetwork();
        }
        console.log("wallet", wallet);
    }, [wallet]);

    const [selectedCrypto, setSelectedCrypto] = useState("ETH");

    const handleRadioChange = (event) => {
        setSelectedCrypto(event.target.value);
    };
    const [message, setMessage] = useState("");
    useEffect(() => {
        console.log("address: ", address, " chainId: ", chainId);
        if (!address || !chainId) {
            setMessage(`${selectedCrypto} wallet is not selected`);
            return;
        }

        const chainMap = {
            ETH: 1, // Ethereum Mainnet
            BNB: 56, // BNB Smart Chain
            SOL: 101, // Example chainId for Solana — replace with actual if needed
        };

        if (selectedCrypto && chainId !== chainMap[selectedCrypto]) {
            setMessage(`${selectedCrypto} wallet is not selected`);
        } else {
            setMessage("");
        }
    }, [selectedCrypto, address, chainId]);

    const handlePayment = () => {
        if (selectedCrypto === "ETH") {
            handleSendEth();
            return; // Stop further execution if ETH logic is handled here
        } else if (selectedCrypto === "SOL") {
            handleSendSol();
            return; // Stop further execution if BNB logic is handled here
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const referrerId = urlParams.get("ref");
        console.log("Loginpopup Ref ID: ", referrerId);

        if (referrerId) {
            setIsReferrer(true);
        }
    }, []);
    const connection = new Connection(
        "https://alpha-crimson-diagram.solana-mainnet.quiknode.pro/12683d2983a09482058b04c03b66a20eff0732b6/",
        "confirmed"
    );
    const loginSource = sessionStorage.getItem("loginSource");
    const getText = () => {
        if (loginSource) {
            sessionStorage.removeItem("loginSource");
        }
        if (loginSource === "addToPortfolio") {
            return "Add Your Portfolio for Best Buy-Sell Recommendations";
        }
        if (location.pathname === "/predict-now") {
            return "Predict accurately and win $wisecoins worth $5";
        }
        if (location.pathname === "/my-portfolio" || location.pathname === "/audit-my-portfolio") {
            return "Add Your Portfolio for Best Buy-Sell Recommendations";
        }
        if (matchPath("/crypto/:crypto", location.pathname) || location.pathname === "/crypto-screener") {
            return "Premium Signals @ $1 per month";
        }
        return "Sign up and Earn 1000 Wisecoins";
    };

    const shouldDisplayImage =
        loginSource === "addToPortfolio" ||
        location.pathname === "/my-portfolio" ||
        location.pathname === "/audit-my-portfolio";

    const handleSendEth = async () => {
        const userId = userData?.user_id || null;

        if (!select_price && walletProvider) {
            alert("Please select an amount");
            return;
        }
        console.log("select_price", select_price);
        try {
            console.log("!address || blockchain", address, blockchain);
            // setLoading(true);
            const response = await fetch(
                "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd"
            );
            const data = await response.json();
            console.log(data);
            const ethPriceInUsd = data.ethereum.usd;

            const priceInUSD = select_price;
            const ethToPay = priceInUSD / ethPriceInUsd;
            console.log("Ethereum price in USD:", ethPriceInUsd, ethToPay, chainId, walletProvider);

            const provider = new ethers.BrowserProvider(walletProvider, chainId);
            const signer = await provider.getSigner();
            const userAddress = await signer.getAddress();

            console.log("Provider:", provider);
            console.log("Signer:", signer);
            console.log("Address:", userAddress);

            // const balance =  await provider.getBalance(userAddress).then((balance) => {
            //     console.log("Balance:", balance);
            //     return balance;
            // });
            // console.log("balance", balance);
            // const balanceInEth = ethers.formatEther(balance);
            // // console.log("User Balance:", balanceInEth, "ETH");
            // console.log("ETH Required:", ethToPay, balance,"ETH");

            // if (parseFloat(balanceInEth) < parseFloat(ethToPay)) {
            //     alert("Insufficient balance. Please add more ETH to your wallet.");
            //     return;
            // }

            setLoading(true);
            const transactionResponse = await initiateTransaction(signer, ethToPay);

            await updateUserSubscriptionWithWllet(userId, "Screener360");
            console.log("cdskmlkdvm");

            setIsSuccess(true);
            // onClose();
        } catch (error) {
            console.error("Transaction failed:", error);

            if (
                error?.code === "ACTION_REJECTED" ||
                error?.code === 4001 ||
                error?.reason === "rejected" ||
                error?.message?.includes("User denied transaction signature")
            ) {
                setProcessingError("Transaction request rejected by user");
            } else if (
                error?.code === "INSUFFICIENT_FUNDS" ||
                error?.message?.toLowerCase().includes("insufficient funds")
            ) {
                setProcessingError("Insufficient funds to complete transaction");
            } else {
                setProcessingError("Transaction failed: something went wrong");
            }
        } finally {
            setLoading(false);
        }
    };
    const initiateTransaction = async (signer, ethToPay) => {
        // Ensure ethToPay is a number or can be converted to a number
        const fixedValue = Number(ethToPay).toFixed(18); // max 18 decimals

        const tx = {
            to: ethRecipientAddress,
            value: ethers.parseEther(fixedValue),
        };

        console.log("Prepared transaction:", tx);
        const response = await signer.sendTransaction(tx);
        console.log("Transaction response:", response);
        return response.wait();
    };

    const initiateTransactionSol = async (connection, address, solToPay) => {
        if (!provider || !provider.publicKey) {
            throw new Error("Wallet is not connected.");
        }

        const senderWallet = provider.publicKey; // Get sender's public key
        const recipientWallet = new PublicKey(recipientAddress); // Recipient's wallet address

        // Fetch latest blockhash
        const {blockhash, lastValidBlockHeight} = await connection.getLatestBlockhash();

        // Create the transaction
        const transaction = new Transaction().add(
            SystemProgram.transfer({
                fromPubkey: senderWallet,
                toPubkey: recipientWallet,
                // lamports: LAMPORTS_PER_SOL * 0.00001, // Amount to send

                lamports: LAMPORTS_PER_SOL * solToPay,
            })
        );

        transaction.feePayer = senderWallet;
        transaction.recentBlockhash = blockhash;

        // Check if provider supports signing transactions
        if (provider.signTransaction) {
            const signedTransaction = await provider.signTransaction(transaction);
            const signature = await connection.sendRawTransaction(signedTransaction.serialize());
            await connection.confirmTransaction({signature, blockhash, lastValidBlockHeight});

            return signature;
        }
        // Solflare-specific transaction handling
        else if (provider.signAndSendTransaction) {
            const {signature} = await provider.signAndSendTransaction(transaction);
            await connection.confirmTransaction(signature, {commitment: "confirmed"});

            return signature;
        } else {
            throw new Error("Wallet provider does not support signing transactions.");
        }
    };

    const handleSendSol = async () => {
        try {
            setLoading(true);
            console.log("walletAddress, walletAddress", address, connection);
            const balance = await connection.getBalance(new PublicKey(address));
            console.log("walletAddress, walletAddress", balance, address, connection);
            const balanceInSol = balance / LAMPORTS_PER_SOL;
            const response = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd");
            const data = await response.json();
            const solPriceInUsd = data.solana.usd;

            const priceInUSD = select_price;
            const solToPay = priceInUSD / solPriceInUsd;

            if (parseFloat(solToPay) > parseFloat(balanceInSol)) {
                setAlertMessage("Insufficient balance. Please add more SOL to your wallet.");
                setSnackbarOpen(true);
                setSeverity("error");
                setTimeout(() => {
                    setSnackbarOpen(false);
                }, [2000]);
                return;
            }

            const transactionResponse = await initiateTransactionSol(connection, walletAddress, solToPay);

            await saveCryptoPresalePayment(recipientAddress, walletAddress, transactionResponse, priceInUSD, "sol");

            setIsSuccess(true);
        } catch (error) {
            console.error("Error sending SOL:", error);
            alert("Error sending SOL: " + error.message ? error.message : error);
        } finally {
            setLoading(false);
        }
    };
    const styles = {
        overlay: {
            position: "fixed",
            top: mediaQueryVar === true ? 0 : "auto",
            bottom: mediaQueryVar === true ? "auto" : "30%",
            left: 0,
            width: "100%",
            height: mediaQueryVar === true ? "100%" : "auto",
            backgroundColor: mediaQueryVar === true ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0.0)",
            display: "flex",
            justifyContent: "center",
            alignItems: mediaQueryVar === true ? "center" : "flex-end",
            zIndex: 10000,
            paddingBottom: 0,
        },
        popupContainer: {
            width: mediaQueryVar === false ? "75%" : "480px",
            padding: mediaQueryVar === false ? "0px" : "10px",
            background: "linear-gradient(90deg, #9AEB37 0%, #FFF73F 100%)",
            borderRadius: mediaQueryVar === false ? "24px" : "24px",
            borderTopLeftRadius: mediaQueryVar === true ? "24px" : "24px",
            borderTopRightRadius: mediaQueryVar === true ? "24px" : "24px",
            textAlign: "center",
            paddingTop: "0px",
            paddingBottom: mediaQueryVar === false ? "10px" : "",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        },
        popupContent: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "30px 0px",
        },
        image: {
            width: mediaQueryVar === false ? "145px" : "160px",
            height: "40px",
            marginTop: mediaQueryVar === false ? "-45px" : "-30px",
            marginBottom: "10px",
        },
        heading: {
            fontSize: mediaQueryVar === false ? "15px" : "18px",
            fontWeight: "bold",
            color: "#000",
        },
        text: {
            fontSize: mediaQueryVar === false ? "17px" : "20px",
            color: "#1877F2",
            marginBottom: mediaQueryVar === false ? "0px" : "8px",
            lineHeight: "24px",
        },
        boldText: {
            fontSize: mediaQueryVar === false ? "16px" : "18px",
            fontWeight: "bold",
            color: "black",
        },
        signupButton: {
            width: "80%",
            backgroundColor: "#1877F2",
            color: "#fff",
            padding: mediaQueryVar === true ? "9px 20px" : "3px 20px",
            borderRadius: "1000px",
            border: "none",
            fontSize: "16px",
            cursor: "pointer",
            marginBottom: "2px",
            marginTop: "8px",
        },
        laterButton: {
            display: mediaQueryVar === false ? "none" : "block",
            backgroundColor: "transparent",
            color: "#1877F2",
            padding: "5px",
            border: "none",
            fontSize: "17px",
            cursor: "pointer",
        },
    };
    // return <SuccessPaymentAlert open={isSuccess} onClose={() => setIsSuccess(false)} />;
    return isSuccess ? (
        <SuccessPaymentAlert
            open={true}
            onClose={() => {
                setIsSuccess(false);
                onClose();
            }}
            button={<button className="btn btn-primary rounded-pill" onClick={() => navigate("/my-subscriptions")}>Access Subscriptions</button>}
        />
    ) : loading ? (
        <ProcessingAlert />
    ) : (
        <div style={styles.overlay}>
            <div style={styles.popupContainer}>
                {mediaQueryVar === false && (
                    <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                            style={{
                                width: "48px",
                                height: "4px",
                                borderRadius: "100px",
                                background: "#E2E2E2",
                                border: "none",
                                margin: "5px",
                            }}
                        ></button>
                    </div>
                )}

                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <img
                        className="frameIcon"
                        alt=""
                        onClick={loading ? null : onClose}
                        src={`${window.constants.asset_path}/images/frame17.svg`}
                        style={{
                            background: "#F3F3F3",
                            width: "30px",
                            height: "30px",
                            marginTop: "10px",
                            marginRight: "10px",
                        }}
                    />
                </div>

                <div style={styles.popupContent}>
                    {!shouldDisplayImage && (
                        <img
                            src={`${window.constants.asset_path}/images/logo.png`}
                            alt="Wise coins logo"
                            style={styles.image}
                        />
                    )}

                    <p style={styles.text}>
                        <strong>{getText()}</strong>
                        <br></br>
                    </p>

                    <div>
                        <h3>Select One Cryptocurrency</h3>

                        <label>
                            <input
                                type="radio"
                                value="SOL"
                                checked={selectedCrypto === "SOL"}
                                onChange={handleRadioChange}
                                disabled={loading}
                            />
                            SOL
                        </label>
                        <br />

                        <label>
                            <input
                                type="radio"
                                value="ETH"
                                checked={selectedCrypto === "ETH"}
                                onChange={handleRadioChange}
                                disabled={loading}
                            />
                            ETH
                        </label>
                        <br />

                        <label>
                            <input
                                type="radio"
                                value="BNB"
                                checked={selectedCrypto === "BNB"}
                                onChange={handleRadioChange}
                                disabled={loading}
                            />
                            BNB
                        </label>

                        <br />
                        <p>Selected: {selectedCrypto || "None"}</p>
                        <p>{selectedCrypto != "ETH" ? "Other payment options are coming soon.." : message}</p>
                    </div>
                    {loading ? (
                        <div>
                            <b>Processing...</b>
                            <br />
                            <small>confirm payment in your wallet</small>
                        </div>
                    ) : (
                        processingError && (
                            <div>
                                <b style={{color: "red"}}>{processingError}</b>
                            </div>
                        )
                    )}
                    <button
                        style={styles.signupButton}
                        onClick={() => {
                            handlePayment();
                        }}
                        disabled={loading || selectedCrypto != "ETH"}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : "Pay Crypto"}
                    </button>

                    <hr style={{width: "80%", border: "1px solid rgb(61, 60, 60)"}}></hr>

                    <div style={{display: "flex", flexDirection: "row", gap: "20px"}}>
                        <a href="https://investing.crowdwisdom.live/termofuse">Terms of Use</a>
                        <a href="https://investing.crowdwisdom.live/privacyPolicy">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WalletPayment;
